import {Request} from "../core/request";
import {AuthHeader} from "../core/token";

export interface CourseLocation {
    ID: number;
    Name: string,
    Remark: string,
}


// 地址
export async function getCourseLocation(): Promise<CourseLocation[]> {
    const result = await Request.get<CourseLocation[]>(`super_admin/course_location/`, {headers: AuthHeader()})
    return result.data
}

export async function createCourseLocation(name: string, remark: string) {
    return await Request.post(`super_admin/course_location/`, {
        name: name, remark: remark,
    }, {headers: AuthHeader()})
}


export async function deleteCourseLocation(id: number) {
    return await Request.delete(`super_admin/course_location/${id}`, {headers: AuthHeader()})
}


export interface CourseSubject{
    ID: number;
    Name: string;
}

// 课程
export async function getSubject(): Promise<CourseSubject[]> {
    const result = await Request.get<CourseSubject[]>(`super_admin/subject/`, {headers: AuthHeader()})
    return result.data
}

export async  function createSubject(name: string) {
    return await Request.post(`super_admin/subject/`, {
        name: name,
    }, {headers: AuthHeader()})
}

export async function deleteSubject(id: number) {
    return await Request.delete(`super_admin/subject/${id}`, {headers: AuthHeader()})
}
